import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { MousePositionComponent } from './mouse-position.component';
import { TelusFormModule } from '../../form/form.module';
import { TableModule } from '../../table/table.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    TelusFormModule,
    TableModule,
  ],
  declarations: [MousePositionComponent],
  exports: [MousePositionComponent],
})
export class TelusMousePositionModule {}
